<script setup lang="ts">
import { useCommonStore } from '@stores/common'

import { useSidebarItems } from '@hooks/sidebar/sidebar-items.hook'
import { useSidebarDrawer } from '@hooks/sidebar/sidebar-drawer.hook'

import { faBars } from '@fortawesome/pro-regular-svg-icons'

import AdminDropdown from '@Molecules/Auth/AdminDropdown.vue'
import { SidebarMenu } from '@UI/Menus/SidebarMenu'
import { ToastProvider } from '@UI/Toast/ToastProvider'
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'
import { BtnIcon } from '@UI/Buttons/BtnIcon'

defineOptions({
  name: 'AdminLayout',
})

const config = useRuntimeConfig()
const isProduction = config.public.environment === 'production'
const commonStore = useCommonStore()

const { refItems } = useSidebarItems()
const { refIsDrawerOpen, setDrawer } = useSidebarDrawer()
</script>

<template>
  <div>
    <div class="admin-layout">
      <SidebarMenu
        :items="refItems"
        :is-production="isProduction"
        :is-drawer-open="refIsDrawerOpen"
        @click:close="setDrawer(false)"
      />
      <nav class="admin-layout__nav">
        <div class="nav-container">
          <div class="nav-container__row">
            <BtnIcon
              class="nav-container__menu"
              :icon="faBars"
              title="Open menu"
              @click="setDrawer(true)"
            />
            <div
              v-if="$slots.header"
              class="nav-container__header"
            >
              <slot name="header" />
            </div>
            <AdminDropdown class="nav-container__account" />
          </div>
        </div>
        <div
          v-if="$slots.tabs"
          class="tabs-container"
        >
          <slot name="tabs" />
        </div>
      </nav>

      <main class="main-layout">
        <div
          v-if="$slots.filters"
          class="main-layout__filters"
        >
          <slot name="filters" />
        </div>
        <slot
          v-if="$slots.default"
        />
        <LoaderOverlay v-if="commonStore.isLoading" />
      </main>
    </div>
  </div>

  <ToastProvider />
</template>

<style scoped lang="scss" src="@scss/layouts/admin-layout.scss" />
